/**
 * @fileoverview
 * UI State Models
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export interface Theme {
  mode: 'light' | 'dark';
  primaryColor: string;
}

export interface Sidebar {
  collapsed: boolean;
  activeMenu: string | null;
}

export interface Breadcrumb {
  label: string;
  url: string;
  icon?: string;
}

export interface UIState {
  theme: Theme;
  sidebar: Sidebar;
  breadcrumbs: Breadcrumb[];
  isFullscreen: boolean;
  showMobileMenu: boolean;
}

export const DEFAULT_UI_STATE: UIState = {
  theme: {
    mode: 'light',
    primaryColor: '#3B82F6'
  },
  sidebar: {
    collapsed: false,
    activeMenu: null
  },
  breadcrumbs: [],
  isFullscreen: false,
  showMobileMenu: false
};

